<template>
  <div class="vx-row" id="manualRebatesDiv-with-loading">
    <vx-card class="centered-page-container">
      <div class="vx-row flex-wrap px-5">
        <h2 class="partner-page-title"> Delete Rebate File </h2>
      </div>

      <hr>

      <form class="add-partner-tabs" @submit.prevent="openConfirm">
        <div class="vx-row mt-6">
          <div class="vx-col w-1/4">
            <label class="vs-input--label mt-2 pb-1 flex justify-between">
              <span>Falcon Rebate File Name *</span>
              <span class="mr-0">
                <vx-tooltip text="Enter the name of the falcon rebate file you want to delete" position="top">
                  <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null"></i>
                </vx-tooltip>
              </span>
            </label>
            <vs-input
              class="w-full"
              :v-validate="{ required: !formData['rebateFileName'] }"
              name="Rebate File Name"
              data-vv-validate-on="change"
              v-model="formData['rebateFileName']"
              :danger="errors.has('Rebate File Name')"
              danger-text="Required field" />
          </div>
        </div>

        <hr class="my-8">
    
        <div class="vx-row">
          <vs-button class="mt-2 ml-auto" type="filled" button="submit" icon-pack="feather" icon="icon-trash">Delete</vs-button>
        </div>
      </form>
    </vx-card>

    <!-- @cancel="" -->
    <vs-prompt
      class="manual-rebates-prompt"
      @accept="submit"
      :acceptText="confirmPrompt['acceptText']"
      :cancelText="confirmPrompt['cancelText']"
      :title="confirmPrompt['title']"
      :color="confirmPrompt['color']"
      :active.sync="confirmPrompt['activePrompt']">
        {{ confirmPrompt['content'] }}
    </vs-prompt>
  </div>
</template>

<script>
export default {
  name: 'ManualRebates',
  data() {
    return {
      // Define your data properties here
      formData: {
        rebateFileName: ''
      },
      confirmPrompt: {
        activePrompt: false,
        title: '',
        content: '',
        acceptText: '',
        cancelText: '',
        color: '',
      },
    };
  },
  methods: {
    // Define your methods here
    openLoadingInAgtDiv() {
      this.$vs.loading({
        container: "#manualRebatesDiv-with-loading",
        scale: 0.6,
      });
    },
    hideLoadingInAgtDiv() {
      this.$vs.loading.close("#manualRebatesDiv-with-loading > .con-vs-loading");
    },
    openConfirm() {
      this.confirmPrompt['acceptText'] = 'Delete';
      this.confirmPrompt['cancelText'] = 'Cancel';
      this.confirmPrompt['title'] = 'Confirm Delete Rebate File';
      this.confirmPrompt['content'] = 'Deleting Falcon rebate file. Are you sure?';
      this.confirmPrompt['color'] = 'danger';
      this.confirmPrompt['activePrompt'] = true;
    },
    submit() {
      this.$validator.validate().then(async valid => {
        this.openLoadingInAgtDiv();
        if(valid) {
          let payload = {
            falcon_file_name: this.formData['rebateFileName']
          };
          try {
            // Call the API to delete the rebate file
            await this.$axiosSecure.post('/delete-rebate', payload);
            this.hideLoadingInAgtDiv();

            this.$vs.notify({
              title: 'Success',
              text: 'Rebate file deleted successfully.',
              color: 'success',
            });
            // Optionally, reset the form or redirect
            this.formData['rebateFileName'] = '';
          } catch (error) {
            this.hideLoadingInAgtDiv();

            this.$vs.notify({
              title: 'Error',
              text: error.response ? error.response.data.message : 'Failed to delete rebate file.',
              color: 'danger',
            });
          }
        } else {
          this.hideLoadingInAgtDiv();

          this.$vs.notify({
            title: 'Validation Error',
            text: 'Please fill in all required fields.',
            color: 'warning',
          });
        }
      });
    }
  },
  mounted() {
    // Code to run when the component is mounted
  }
}
</script>